export class LogoutRequest {
    jwtToken: string;
    refreshToken: string;
} 